var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.825,
    height: 11.95,
    viewBox: "0 0 17.825 11.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8784",
    "data-name": "Group 8784",
    transform: "translate(-27.9 -419.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8777",
    "data-name": "Group 8777",
    transform: "translate(28 419.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8776",
    "data-name": "Group 8776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18767",
    "data-name": "Path 18767",
    d: "M16.156,80H1.469A1.47,1.47,0,0,0,0,81.469v8.812A1.47,1.47,0,0,0,1.469,91.75H16.156a1.47,1.47,0,0,0,1.469-1.469V81.469A1.47,1.47,0,0,0,16.156,80Zm.881,10.281a.881.881,0,0,1-.881.881H1.469a.881.881,0,0,1-.881-.881V81.469a.881.881,0,0,1,.881-.881H16.156a.881.881,0,0,1,.881.881Z",
    transform: "translate(0 -80)",
    fill: "#363954",
    stroke: "#363954",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8785",
    "data-name": "Group 8785",
    transform: "translate(0 0.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8779",
    "data-name": "Group 8779",
    transform: "translate(30.917 420.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8778",
    "data-name": "Group 8778",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18768",
    "data-name": "Path 18768",
    d: "M43.946,112.106a.234.234,0,0,0-.313-.075l-5,2.875a1.179,1.179,0,0,1-1.173,0l-5-2.875a.233.233,0,0,0-.312.08.214.214,0,0,0,.077.295l5,2.875a1.652,1.652,0,0,0,1.642,0l5-2.875A.214.214,0,0,0,43.946,112.106Z",
    transform: "translate(-32.122 -112)",
    fill: "#9ba9b8",
    stroke: "#9ba9b8",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8781",
    "data-name": "Group 8781",
    transform: "translate(30 422.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8780",
    "data-name": "Group 8780",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18769",
    "data-name": "Path 18769",
    d: "M32.243,144a.229.229,0,0,0-.243.213v5.532a.245.245,0,0,0,.486,0v-5.532A.229.229,0,0,0,32.243,144Z",
    transform: "translate(-32 -144)",
    fill: "#9ba9b8",
    stroke: "#9ba9b8",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8783",
    "data-name": "Group 8783",
    transform: "translate(43.4 422.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8782",
    "data-name": "Group 8782",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18770",
    "data-name": "Path 18770",
    d: "M432.263,144a.242.242,0,0,0-.263.213v5.534a.269.269,0,0,0,.526,0v-5.534A.242.242,0,0,0,432.263,144Z",
    transform: "translate(-432 -144)",
    fill: "#9ba9b8",
    stroke: "#9ba9b8",
    strokeWidth: 0.4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.edf323c6c6fb1a00860fbbcdfd00d287.svg";
export { ForwardRef as ReactComponent };